<template>
    <v-card flat color="transparent" class="w-100 align-self-start">
        <v-card-title>
            <span class="secondary--text">{{ title }}</span>
            <span v-if="section" class="secondary--text mx-2"><v-icon>mdi-chevron-right</v-icon></span>
            <span v-if="section" class="secondary--text">{{ section }}</span>
        </v-card-title>
        <v-card-text>
            <slot />
        </v-card-text>
    </v-card>
</template>

<script>
export default {
    name: 'SettingsWrapper',
    props: {
        title: {
            type: String,
            required: true
        },
        section: {
            type: String,
            default: ''
        }
    }
}
</script>
